<template>
  <div class="scroll-births-and-hired">
    <div>
      <div v-if="loading" class="d-flex justify-center align-center h-64">
        <vue-element-loading :active="loading" spinner="mini-spinner" color="#004250"/>
      </div>
      <div v-show="!loading">
        <div v-for="item in filterLimitRow" :key="item.id">
          <div class="flex items-center px-3 py-3">
            <div class="recentTitle sm:1/4 xs:1/4 md:1/4 lg:1/6 xl:1/6 md:px-4 flex flex-col justify-center">
              <div class="text-zt-lg font-bold capitalize">{{ formatDay(item.fechaAbsent) }}</div>
              <div class="text-zt-base font-normal text-zt-secondary-200">{{ item.fechaAbsent }}</div>
              <div
                v-if="item.dateToShow && item.data.length > numberShow"
                class="mt-2"
              >
                <zt-button
                  class="text-zt-primary-200"
                  @click="(item.dateToShow = false) +(showMore(item.dateEs))"
                  color="primary"
                  outlined
                  icon="angle-down"
                  fab
                  data-vs-button="delete"
                ></zt-button>
              </div>
              <div
                v-if="!item.dateToShow && item.data.length > numberShow"
                class="mt-2"
              >
                <zt-button
                  class="text-zt-primary-200"
                  @click="(item.dateToShow = true) + (showLess(item.dateEs))"
                  color="primary"
                  outlined
                  icon="angle-up"
                  fab
                  data-vs-button="add"
                ></zt-button>
              </div>
            </div>
            <div :id="item.dateEs" class="d-flex flex-wrap rowsDiv items-center">
              <div v-for="(element, index) in item.data"
                :key="index"
                class="sm:3/4 xs:3/4 md:3/4 lg:5/6 xl:5/6 p-1 recentContainer">
                <zt-tooltip :text="`${element.name} ${element.lastname}`" color="primary">
                  <div
                    class="w-12 h-12 rounded-full flex items-center justify-center"
                    :class="element.avatar != '' && element.avatar.includes('/profileimage') ? '' : 'bg-white border border-solid border-primary text-zt-primary-200'"
                  >
                    <img
                      class="rounded-full"
                      v-if="element.avatar != '' && element.avatar.includes('/profileimage')"
                      :src="element.avatar"
                    />
                    <div v-else>{{element.name.trim().charAt(0).toUpperCase() + element.lastname.trim().charAt(0).toUpperCase()}}</div>
                  </div>
                </zt-tooltip>
              </div>
            </div>
          </div>
          <hr />
        </div>
      </div>
      <div v-if="!loading" class="text-right">
        <button
          v-if="limitRow == 5 && Rows.length > 5"
          class="sm:3/4 xs:3/4 md:3/4 lg:5/6 xl:5/6 py-4 font-normal text-gray-600 focus:outline-none mr-2"
          @click="limitRow = ''"
          data-vs-button="show_more"
        >{{ $t('message.homeComponent.recentHired.show_more') }}</button>
        <button
          v-if="!limitRow && Rows.length > 5"
          class="sm:3/4 xs:3/4 md:3/4 lg:5/6 xl:5/6 py-4 font-normal text-gray-600 focus:outline-none mr-2"
          @click="limitRow = 5"
          data-vs-button="show-less"
        >{{ $t('message.homeComponent.recentHired.show_minus') }}</button>
      </div>
      <div
        v-if="!loading && !Rows.length"
        class="sm:3/4 xs:3/4 md:3/4 lg:5/6 xl:5/6 p-1 py-10 text-center"
      >
        <div
          class="h-12 text-zt-dark-300 rowsDiv flex items-center justify-center font-normal"
        >{{ $t('message.homeComponent.recentHired.no_events') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import User from '../../apiClient/User'
import moment from 'moment'
import { mapGetters } from 'vuex'
import _  from 'lodash'
import VueElementLoading from 'vue-element-loading';

export default {
  components: {
    VueElementLoading
  },
  props: {
    handlerFilter: Boolean,
    filterSector: String
  },
  data() {
    return {
      loading: true,
      Rows: [],
      fullData: [],
      filteredData: [],
      sectores: [],
      numberShow: 8,
      limitRow: 1,
      show:false,

    }
  },
  computed: {
    ...mapGetters(['getUser']),
    sliceDate() {
      return date => date.slice(0, -8)
    },
    filterLimitRow() {
      return this.limitRow ? this.Rows.slice(0, this.limitRow) : this.Rows
    }
  },
  created() {
    this.user = new User()
    this.getAbsents()
    this.detectResolution()
  },
  methods: {
    detectResolution() {
      let resolution = window.screen.width;
      switch (true) {
        case (resolution < 500):
          this.numberShow = 6;
          break;
        case (resolution >= 501 && resolution <= 1023):
          this.numberShow = 9;
          break;
        case (resolution >= 1024 && resolution <= 1279):
          this.numberShow = 60;
          break;
        case (resolution >= 1280 && resolution <= 1439):
          this.numberShow = 72;
          break;
        case (resolution >= 1440 && resolution <= 1599):
          this.numberShow = 90;
          break;
        case (resolution >= 1600 && resolution <= 1919):
          this.numberShow = 102;
          break;
        case (resolution >= 1920 && resolution <= 2047):
          this.numberShow = 132;
          break;
        case (resolution >= 2048):
          this.numberShow = 138;
          break;
      }
    },
    async getAbsents() {
      const today = new Date()
      const desde = moment(today).format('DD/MM/YYYY')
      try {
        const { data } = await this.user.getAbsents()
        this.fullData = data.data
        console.log(this.fullData)
        this.filteredData = data.data
        this.buildData(data.data)
        this.loading = false
      } catch (e) {
        this.loading = false
      }
    },
    formatDay(day){
      let today = new Date();
      if(moment(today).subtract(1,'days').format('DD/MM/YYYY') === moment(day,'DD/MM/YYYY').format('DD/MM/YYYY')) {
        // ayer
        return this.$t('message.homeComponent.birthdays.yesterday');
      } else if(moment(today).format('DD/MM/YYYY') === moment(day,'DD/MM/YYYY').format('DD/MM/YYYY')) {
        // hoy
        return this.$t('message.homeComponent.birthdays.today');
      } else if(moment(today).add(1,'days').format('DD/MM/YYYY') === moment(day,'DD/MM/YYYY').format('DD/MM/YYYY')) {
        // manana
        return this.$t('message.homeComponent.birthdays.tomorrow');
      } else {
        return moment(day,'DD/MM/YYYY').locale("es").format('dddd');
      }
    },
    buildData(data) {
      //this.$store.dispatch('setHomeSectoresRecentHired', this.sectores);
      this.Rows = [];
      this.filteredData = this.fullData;
      
      const today = new Date();
      const totalRow = this.filteredData
      const year = new Date().getFullYear()

      //solo para demo sacar despues de la demo
      if(window.location.href.indexOf('demo') > -1 && (window.location.href.indexOf('localhost') > -1 || window.location.href.indexOf('intlocal') > -1 || window.location.href.indexOf('devlocal') > -1)){
        let arrDummy = []
        for (let i = 0; i < 100; i++){
          arrDummy.push(
            {
                "id": 288382,
                "name": "GUSTAVO RAUL",
                "lastname": "AGUILERA",
                "sector": "DIRECCIÓN DE PEOPLE & CULTURE Y TALENT SOLUTIONS",
                "location": "WE WORK",
                "avatar": ""
              }
          )
        }
        this.filteredData = this.filteredData.concat(arrDummy)
      }

      this.filteredData = this.filteredData.map(a => {
        a['dmy'] = moment(today).format('DD/MM/YYYY')
        return a
      })
      for (let i = 0; i < totalRow.length; i++) {
        this.Rows.push({
          dateEn: moment(today).format('YYYY/MM/DD'),
          dateEs: moment(today).format('DD/MM'),
          ddmm: moment(today)
            .locale('es')
            .format('LL'),
          fecha: moment(today).format('MM/DD/YYYY'),
          fechaAbsent: moment(today).format('DD/MM/YYYY'),
          data: this.filteredData,
          dateToShow: true
        })
      }
      
    },
    filterData(date) {
      let today = moment().format('YYYY-MM-DDT00:00:00Z')
      today = new Date(today)
      let filteredData = this.filteredData.filter(result => {
        let desde = moment(result.fecha_desde,'DD/MM/YYYY').format('YYYY-MM-DDT00:00:00Z')
        desde = new Date(desde)
        let hasta = moment(result.fecha_regreso,'DD/MM/YYYY').format('YYYY-MM-DDT00:00:00Z')
        hasta = new Date(hasta)
        return today >= desde && today <= hasta
      }) 

      if(!filteredData.length){
        this.Rows = []
      }
      
      return filteredData
     
      
    },
    showMore(id) {
      document.getElementById(id).classList.remove('rowsDiv')
    },
    showLess(id) {
      document.getElementById(id).classList.add('rowsDiv')
    }
  },
  watch: {
    filterSector: function() { 
      this.buildData(this.fullData);
    }
	}
}
</script>

<style lang="scss" scoped>
@import './public/assets/scss/_config.scss';

.recentTitle {
  min-width: 150px;
}

.recentContainer {
  max-width: 60px;
  font-size: $font-small;
}

.border-primary {
  border-color: $primary-color-200;
}

::v-deep .border-primary {
  border-color: $primary-color-200 !important;
}

::v-deep .text-zt-primary-200 {
    color: $primary-color-200 !important;
}

.rowsDiv {
  @media (min-width: 900px) {
    $line-height: 3;
    $font-size: 15px;
    $lines: 6;
    display: block;
    display: -webkit-box;
    //height: $font-size * $line-height * $lines;
    height: auto;
    max-height: 270px;
    font-size: $font-size;
    line-height: $line-height;
    -webkit-line-clamp: $lines;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @media (max-width: 900px) {
    align-items: center;
    $lines: 8;
    $font-size: 14px;
    $line-height: 1;
    display: block;
    display: -webkit-box;
    height: $font-size * $line-height * $lines;
    font-size: $font-size;
    line-height: $line-height;
    -webkit-line-clamp: $lines;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>